import React from "react";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Content from "./Components/Content/Content";

function index() {
	return (
		<div className="static">
			<Header />
			<Content />
			<Footer />
		</div>
	);
}

export default index;
